import { Typography } from '@material-ui/core';
import { PureComponent } from 'react';
import { NavLink, RouteComponentProps } from 'react-router-dom';
import { Analytics } from '../../helpers/analytics/Analytics';

export class NotFoundScreen extends PureComponent<RouteComponentProps> {
  componentDidMount() {
    const { location } = this.props;
    Analytics.track({
      event: Analytics.Event.p_page_not_found,
      path: location.pathname,
    });
  }

  render() {
    return (
      <div className="App" data-testid="404-page">
        <header className="App-header">
          <h1>
            Oops, sorry!
            <br />
            <Typography variant="body1">We cannot find the page you are looking for...</Typography>
          </h1>
          <p>
            The page you are looking for does not exist or has been moved.
            <br />
            Head back to our homepage and try again!
          </p>
          <NavLink to="/" className="NavLink">
            Go Home
          </NavLink>
        </header>
      </div>
    );
  }
}
